(() => {
function validateSnapshot(value,{audience,now,minRevision=0}){
 const codes=['L01','P01','S01','E01','E02','O01'];
 if(!Number.isSafeInteger(now)||!value||value.schema!=='ns.availability.v2'||value.audience!==audience||!Number.isSafeInteger(value.revision)||value.revision<1||value.revision<minRevision||!Number.isSafeInteger(value.rendered_at)||value.rendered_at>now+60||value.rendered_at<now-120||!Array.isArray(value.offers)||value.offers.length!==6)throw new Error('snapshot_unavailable');
 for(let i=0;i<6;i++){
  const o=value.offers[i];if(!o||o.code!==codes[i]||o.total!==10||!Number.isInteger(o.remaining)||o.remaining<0||o.remaining>10)throw new Error('snapshot_invalid');
 }
 return value;
}
function serverTime(headers){
 const date=Date.parse(headers.get('Date')||'');const age=Number(headers.get('Age')||0);
 if(!Number.isFinite(date)||!Number.isSafeInteger(age)||age<0)throw new Error('server_time_unavailable');
 return Math.floor(date/1000)+age;
}

// GET of the current page's aggregate counts only; never submits or reserves.
(() => {
 let dispose;
 const initialize=()=>{
  const root=document.getElementById('cs-ns');
  if(!root||root.dataset.nsAvailabilityBound||!root.dataset.nsAudience)return;
  if(dispose)dispose();root.dataset.nsAvailabilityBound='true';
  const lifecycle=new AbortController();let request,timeout,refreshTimer,expiryTimer,closingTimer,revision=0,active=true,failures=0,closed=false;
  const targets=[...root.querySelectorAll('[data-ns-availability]')];
  if (targets.length !== (root.dataset.nsVoucherDetail === 'true' ? 1 : 6)) return;
  let preopen=targets.every(t=>t.textContent.trim()==='Alocările se deschid pe 6 noiembrie.');
  const unavailable=()=>targets.forEach(t=>{t.textContent=closed?'Ediția s-a încheiat.':preopen?'Alocările se deschid pe 6 noiembrie.':'Disponibilitatea se confirmă prin consultant.';});
  const show=(value,now)=>{
   const snapshot=validateSnapshot(value,{audience:root.dataset.nsAudience,now,minRevision:revision});
   revision=snapshot.revision;
   root.dispatchEvent(new CustomEvent('cs-ns:availability-time',{detail:{now}}));
   if(now>=1794175200){closed=true;unavailable();return;}
   preopen=now<1793916000;
   if(preopen){unavailable();return;}
   const time=new Intl.DateTimeFormat('ro-RO',{hour:'2-digit',minute:'2-digit',timeZone:'Europe/Bucharest'}).format(new Date(snapshot.rendered_at*1000));
   for(const offer of snapshot.offers){const t=targets.find(n=>n.dataset.nsAvailability===offer.code);if(!t){if(root.dataset.nsVoucherDetail==='true')continue;throw new Error('missing_card');}t.textContent=offer.remaining===0?'Alocări epuizate · Consultați alternativele cu echipa.':`${offer.remaining}/10 alocări disponibile · Verificat la ${time}`;}
   clearTimeout(expiryTimer);expiryTimer=setTimeout(unavailable,Math.max(0,(snapshot.rendered_at+120-now)*1000));
   clearTimeout(closingTimer);closingTimer=setTimeout(()=>{closed=true;clearTimeout(refreshTimer);request?.abort();unavailable();},(1794175200-now)*1000);
  };
  const refresh=async()=>{
   clearTimeout(refreshTimer);if(!active||closed||document.hidden||request)return;
   request=new AbortController();timeout=setTimeout(()=>request?.abort(),10000);
   try{
    const path=root.dataset.nsAvailabilityPath||window.location.pathname;
    // The server supplies only this edition's canonical path. Keep private
    // handles out of shared assets; the snapshot must match this audience.
    if(!['public','house_client'].includes(root.dataset.nsAudience)||!/^\/pages\/[a-z0-9-]+$/.test(path))throw new Error('availability_path');
    const url=new URL(path,window.location.origin);url.searchParams.set('section_id','cs-ns-availability');
    const preview=new URL(window.location.href).searchParams.get('preview_theme_id');
    if(preview&&/^\d+$/.test(preview))url.searchParams.set('preview_theme_id',preview);
    const response=await fetch(url.href,{method:'GET',credentials:'same-origin',cache:'no-store',signal:request.signal,headers:{'Accept':'text/html'}});
    if(!response.ok)throw new Error('http');
    const html=await response.text();if(html.length>20000)throw new Error('response_size');
    const doc=new DOMParser().parseFromString(html,'text/html'),nodes=doc.querySelectorAll('[data-ns-allocation-snapshot]');
    if(nodes.length!==1)throw new Error('snapshot_missing');
    if(active){show(JSON.parse(nodes[0].textContent),serverTime(response.headers));failures=0;}
   }catch(error){if(active){unavailable();if(error?.name!=='AbortError')failures++;}}
   finally{clearTimeout(timeout);request=null;if(active&&!closed&&!document.hidden)refreshTimer=setTimeout(refresh,Math.min(30000*2**failures,300000));}
  };
  // A cached document and an inaccurate client clock cannot prove freshness.
  // Require a same-origin response Date before displaying numerical claims in JS.
  unavailable();
  root.addEventListener('click',event=>{if(event.target.closest('[data-offer]'))refresh();},{signal:lifecycle.signal});
  document.addEventListener('visibilitychange',()=>{clearTimeout(refreshTimer);if(document.hidden){request?.abort();unavailable();}else refresh();},{signal:lifecycle.signal});
  window.addEventListener('pageshow',()=>{if(!document.hidden)refresh();},{signal:lifecycle.signal});
  dispose=()=>{active=false;request?.abort();clearTimeout(timeout);clearTimeout(refreshTimer);clearTimeout(expiryTimer);clearTimeout(closingTimer);lifecycle.abort();};
  refresh();
 };
 initialize();document.addEventListener('shopify:section:load',initialize);
})();

})();
